// Genere depuis phonenumbers (libphonenumber) + babel locale fr - meme source que la
// validation backend (email_utils.normalize_international_phone), donc les indicatifs
// et la validite des numeros restent coherents entre frontend et backend.
export const COUNTRIES = [
  { iso2: 'AF', name: 'Afghanistan', dialCode: '+93' },
  { iso2: 'ZA', name: 'Afrique du Sud', dialCode: '+27' },
  { iso2: 'AL', name: 'Albanie', dialCode: '+355' },
  { iso2: 'DZ', name: 'Algérie', dialCode: '+213' },
  { iso2: 'DE', name: 'Allemagne', dialCode: '+49' },
  { iso2: 'AD', name: 'Andorre', dialCode: '+376' },
  { iso2: 'AO', name: 'Angola', dialCode: '+244' },
  { iso2: 'AI', name: 'Anguilla', dialCode: '+1' },
  { iso2: 'AG', name: 'Antigua-et-Barbuda', dialCode: '+1' },
  { iso2: 'SA', name: 'Arabie saoudite', dialCode: '+966' },
  { iso2: 'AR', name: 'Argentine', dialCode: '+54' },
  { iso2: 'AM', name: 'Arménie', dialCode: '+374' },
  { iso2: 'AW', name: 'Aruba', dialCode: '+297' },
  { iso2: 'AU', name: 'Australie', dialCode: '+61' },
  { iso2: 'AT', name: 'Autriche', dialCode: '+43' },
  { iso2: 'AZ', name: 'Azerbaïdjan', dialCode: '+994' },
  { iso2: 'BS', name: 'Bahamas', dialCode: '+1' },
  { iso2: 'BH', name: 'Bahreïn', dialCode: '+973' },
  { iso2: 'BD', name: 'Bangladesh', dialCode: '+880' },
  { iso2: 'BB', name: 'Barbade', dialCode: '+1' },
  { iso2: 'BE', name: 'Belgique', dialCode: '+32' },
  { iso2: 'BZ', name: 'Belize', dialCode: '+501' },
  { iso2: 'BM', name: 'Bermudes', dialCode: '+1' },
  { iso2: 'BT', name: 'Bhoutan', dialCode: '+975' },
  { iso2: 'BY', name: 'Biélorussie', dialCode: '+375' },
  { iso2: 'BO', name: 'Bolivie', dialCode: '+591' },
  { iso2: 'BA', name: 'Bosnie-Herzégovine', dialCode: '+387' },
  { iso2: 'BW', name: 'Botswana', dialCode: '+267' },
  { iso2: 'BN', name: 'Brunei', dialCode: '+673' },
  { iso2: 'BR', name: 'Brésil', dialCode: '+55' },
  { iso2: 'BG', name: 'Bulgarie', dialCode: '+359' },
  { iso2: 'BF', name: 'Burkina Faso', dialCode: '+226' },
  { iso2: 'BI', name: 'Burundi', dialCode: '+257' },
  { iso2: 'BJ', name: 'Bénin', dialCode: '+229' },
  { iso2: 'KH', name: 'Cambodge', dialCode: '+855' },
  { iso2: 'CM', name: 'Cameroun', dialCode: '+237' },
  { iso2: 'CA', name: 'Canada', dialCode: '+1' },
  { iso2: 'CV', name: 'Cap-Vert', dialCode: '+238' },
  { iso2: 'CL', name: 'Chili', dialCode: '+56' },
  { iso2: 'CN', name: 'Chine', dialCode: '+86' },
  { iso2: 'CY', name: 'Chypre', dialCode: '+357' },
  { iso2: 'CO', name: 'Colombie', dialCode: '+57' },
  { iso2: 'KM', name: 'Comores', dialCode: '+269' },
  { iso2: 'CG', name: 'Congo-Brazzaville', dialCode: '+242' },
  { iso2: 'CD', name: 'Congo-Kinshasa', dialCode: '+243' },
  { iso2: 'KP', name: 'Corée du Nord', dialCode: '+850' },
  { iso2: 'KR', name: 'Corée du Sud', dialCode: '+82' },
  { iso2: 'CR', name: 'Costa Rica', dialCode: '+506' },
  { iso2: 'HR', name: 'Croatie', dialCode: '+385' },
  { iso2: 'CU', name: 'Cuba', dialCode: '+53' },
  { iso2: 'CW', name: 'Curaçao', dialCode: '+599' },
  { iso2: 'CI', name: 'Côte d’Ivoire', dialCode: '+225' },
  { iso2: 'DK', name: 'Danemark', dialCode: '+45' },
  { iso2: 'DJ', name: 'Djibouti', dialCode: '+253' },
  { iso2: 'DM', name: 'Dominique', dialCode: '+1' },
  { iso2: 'ES', name: 'Espagne', dialCode: '+34' },
  { iso2: 'EE', name: 'Estonie', dialCode: '+372' },
  { iso2: 'SZ', name: 'Eswatini', dialCode: '+268' },
  { iso2: 'FJ', name: 'Fidji', dialCode: '+679' },
  { iso2: 'FI', name: 'Finlande', dialCode: '+358' },
  { iso2: 'FR', name: 'France', dialCode: '+33' },
  { iso2: 'GA', name: 'Gabon', dialCode: '+241' },
  { iso2: 'GM', name: 'Gambie', dialCode: '+220' },
  { iso2: 'GH', name: 'Ghana', dialCode: '+233' },
  { iso2: 'GI', name: 'Gibraltar', dialCode: '+350' },
  { iso2: 'GD', name: 'Grenade', dialCode: '+1' },
  { iso2: 'GL', name: 'Groenland', dialCode: '+299' },
  { iso2: 'GR', name: 'Grèce', dialCode: '+30' },
  { iso2: 'GP', name: 'Guadeloupe', dialCode: '+590' },
  { iso2: 'GU', name: 'Guam', dialCode: '+1' },
  { iso2: 'GT', name: 'Guatemala', dialCode: '+502' },
  { iso2: 'GG', name: 'Guernesey', dialCode: '+44' },
  { iso2: 'GN', name: 'Guinée', dialCode: '+224' },
  { iso2: 'GQ', name: 'Guinée équatoriale', dialCode: '+240' },
  { iso2: 'GW', name: 'Guinée-Bissau', dialCode: '+245' },
  { iso2: 'GY', name: 'Guyana', dialCode: '+592' },
  { iso2: 'GF', name: 'Guyane française', dialCode: '+594' },
  { iso2: 'GE', name: 'Géorgie', dialCode: '+995' },
  { iso2: 'HT', name: 'Haïti', dialCode: '+509' },
  { iso2: 'HN', name: 'Honduras', dialCode: '+504' },
  { iso2: 'HU', name: 'Hongrie', dialCode: '+36' },
  { iso2: 'IN', name: 'Inde', dialCode: '+91' },
  { iso2: 'ID', name: 'Indonésie', dialCode: '+62' },
  { iso2: 'IQ', name: 'Irak', dialCode: '+964' },
  { iso2: 'IR', name: 'Iran', dialCode: '+98' },
  { iso2: 'IE', name: 'Irlande', dialCode: '+353' },
  { iso2: 'IS', name: 'Islande', dialCode: '+354' },
  { iso2: 'IL', name: 'Israël', dialCode: '+972' },
  { iso2: 'IT', name: 'Italie', dialCode: '+39' },
  { iso2: 'JM', name: 'Jamaïque', dialCode: '+1' },
  { iso2: 'JP', name: 'Japon', dialCode: '+81' },
  { iso2: 'JE', name: 'Jersey', dialCode: '+44' },
  { iso2: 'JO', name: 'Jordanie', dialCode: '+962' },
  { iso2: 'KZ', name: 'Kazakhstan', dialCode: '+7' },
  { iso2: 'KE', name: 'Kenya', dialCode: '+254' },
  { iso2: 'KG', name: 'Kirghizstan', dialCode: '+996' },
  { iso2: 'KI', name: 'Kiribati', dialCode: '+686' },
  { iso2: 'XK', name: 'Kosovo', dialCode: '+383' },
  { iso2: 'KW', name: 'Koweït', dialCode: '+965' },
  { iso2: 'RE', name: 'La Réunion', dialCode: '+262' },
  { iso2: 'LA', name: 'Laos', dialCode: '+856' },
  { iso2: 'LS', name: 'Lesotho', dialCode: '+266' },
  { iso2: 'LV', name: 'Lettonie', dialCode: '+371' },
  { iso2: 'LB', name: 'Liban', dialCode: '+961' },
  { iso2: 'LR', name: 'Liberia', dialCode: '+231' },
  { iso2: 'LY', name: 'Libye', dialCode: '+218' },
  { iso2: 'LI', name: 'Liechtenstein', dialCode: '+423' },
  { iso2: 'LT', name: 'Lituanie', dialCode: '+370' },
  { iso2: 'LU', name: 'Luxembourg', dialCode: '+352' },
  { iso2: 'MK', name: 'Macédoine du Nord', dialCode: '+389' },
  { iso2: 'MG', name: 'Madagascar', dialCode: '+261' },
  { iso2: 'MY', name: 'Malaisie', dialCode: '+60' },
  { iso2: 'MW', name: 'Malawi', dialCode: '+265' },
  { iso2: 'MV', name: 'Maldives', dialCode: '+960' },
  { iso2: 'ML', name: 'Mali', dialCode: '+223' },
  { iso2: 'MT', name: 'Malte', dialCode: '+356' },
  { iso2: 'MA', name: 'Maroc', dialCode: '+212' },
  { iso2: 'MQ', name: 'Martinique', dialCode: '+596' },
  { iso2: 'MU', name: 'Maurice', dialCode: '+230' },
  { iso2: 'MR', name: 'Mauritanie', dialCode: '+222' },
  { iso2: 'YT', name: 'Mayotte', dialCode: '+262' },
  { iso2: 'MX', name: 'Mexique', dialCode: '+52' },
  { iso2: 'FM', name: 'Micronésie', dialCode: '+691' },
  { iso2: 'MD', name: 'Moldavie', dialCode: '+373' },
  { iso2: 'MC', name: 'Monaco', dialCode: '+377' },
  { iso2: 'MN', name: 'Mongolie', dialCode: '+976' },
  { iso2: 'MS', name: 'Montserrat', dialCode: '+1' },
  { iso2: 'ME', name: 'Monténégro', dialCode: '+382' },
  { iso2: 'MZ', name: 'Mozambique', dialCode: '+258' },
  { iso2: 'MM', name: 'Myanmar (Birmanie)', dialCode: '+95' },
  { iso2: 'NA', name: 'Namibie', dialCode: '+264' },
  { iso2: 'NR', name: 'Nauru', dialCode: '+674' },
  { iso2: 'NI', name: 'Nicaragua', dialCode: '+505' },
  { iso2: 'NE', name: 'Niger', dialCode: '+227' },
  { iso2: 'NG', name: 'Nigeria', dialCode: '+234' },
  { iso2: 'NU', name: 'Niue', dialCode: '+683' },
  { iso2: 'NO', name: 'Norvège', dialCode: '+47' },
  { iso2: 'NC', name: 'Nouvelle-Calédonie', dialCode: '+687' },
  { iso2: 'NZ', name: 'Nouvelle-Zélande', dialCode: '+64' },
  { iso2: 'NP', name: 'Népal', dialCode: '+977' },
  { iso2: 'OM', name: 'Oman', dialCode: '+968' },
  { iso2: 'UG', name: 'Ouganda', dialCode: '+256' },
  { iso2: 'UZ', name: 'Ouzbékistan', dialCode: '+998' },
  { iso2: 'PK', name: 'Pakistan', dialCode: '+92' },
  { iso2: 'PW', name: 'Palaos', dialCode: '+680' },
  { iso2: 'PA', name: 'Panama', dialCode: '+507' },
  { iso2: 'PG', name: 'Papouasie-Nouvelle-Guinée', dialCode: '+675' },
  { iso2: 'PY', name: 'Paraguay', dialCode: '+595' },
  { iso2: 'NL', name: 'Pays-Bas', dialCode: '+31' },
  { iso2: 'BQ', name: 'Pays-Bas caribéens', dialCode: '+599' },
  { iso2: 'PH', name: 'Philippines', dialCode: '+63' },
  { iso2: 'PL', name: 'Pologne', dialCode: '+48' },
  { iso2: 'PF', name: 'Polynésie française', dialCode: '+689' },
  { iso2: 'PR', name: 'Porto Rico', dialCode: '+1' },
  { iso2: 'PT', name: 'Portugal', dialCode: '+351' },
  { iso2: 'PE', name: 'Pérou', dialCode: '+51' },
  { iso2: 'QA', name: 'Qatar', dialCode: '+974' },
  { iso2: 'HK', name: 'R.A.S. chinoise de Hong Kong', dialCode: '+852' },
  { iso2: 'MO', name: 'R.A.S. chinoise de Macao', dialCode: '+853' },
  { iso2: 'RO', name: 'Roumanie', dialCode: '+40' },
  { iso2: 'GB', name: 'Royaume-Uni', dialCode: '+44' },
  { iso2: 'RU', name: 'Russie', dialCode: '+7' },
  { iso2: 'RW', name: 'Rwanda', dialCode: '+250' },
  { iso2: 'CF', name: 'République centrafricaine', dialCode: '+236' },
  { iso2: 'DO', name: 'République dominicaine', dialCode: '+1' },
  { iso2: 'EH', name: 'Sahara occidental', dialCode: '+212' },
  { iso2: 'BL', name: 'Saint-Barthélemy', dialCode: '+590' },
  { iso2: 'KN', name: 'Saint-Christophe-et-Niévès', dialCode: '+1' },
  { iso2: 'SM', name: 'Saint-Marin', dialCode: '+378' },
  { iso2: 'MF', name: 'Saint-Martin', dialCode: '+590' },
  { iso2: 'SX', name: 'Saint-Martin (partie néerlandaise)', dialCode: '+1' },
  { iso2: 'PM', name: 'Saint-Pierre-et-Miquelon', dialCode: '+508' },
  { iso2: 'VC', name: 'Saint-Vincent-et-les Grenadines', dialCode: '+1' },
  { iso2: 'SH', name: 'Sainte-Hélène', dialCode: '+290' },
  { iso2: 'LC', name: 'Sainte-Lucie', dialCode: '+1' },
  { iso2: 'SV', name: 'Salvador', dialCode: '+503' },
  { iso2: 'WS', name: 'Samoa', dialCode: '+685' },
  { iso2: 'AS', name: 'Samoa américaines', dialCode: '+1' },
  { iso2: 'ST', name: 'Sao Tomé-et-Principe', dialCode: '+239' },
  { iso2: 'RS', name: 'Serbie', dialCode: '+381' },
  { iso2: 'SC', name: 'Seychelles', dialCode: '+248' },
  { iso2: 'SL', name: 'Sierra Leone', dialCode: '+232' },
  { iso2: 'SG', name: 'Singapour', dialCode: '+65' },
  { iso2: 'SK', name: 'Slovaquie', dialCode: '+421' },
  { iso2: 'SI', name: 'Slovénie', dialCode: '+386' },
  { iso2: 'SO', name: 'Somalie', dialCode: '+252' },
  { iso2: 'SD', name: 'Soudan', dialCode: '+249' },
  { iso2: 'SS', name: 'Soudan du Sud', dialCode: '+211' },
  { iso2: 'LK', name: 'Sri Lanka', dialCode: '+94' },
  { iso2: 'CH', name: 'Suisse', dialCode: '+41' },
  { iso2: 'SR', name: 'Suriname', dialCode: '+597' },
  { iso2: 'SE', name: 'Suède', dialCode: '+46' },
  { iso2: 'SJ', name: 'Svalbard et Jan Mayen', dialCode: '+47' },
  { iso2: 'SY', name: 'Syrie', dialCode: '+963' },
  { iso2: 'SN', name: 'Sénégal', dialCode: '+221' },
  { iso2: 'TJ', name: 'Tadjikistan', dialCode: '+992' },
  { iso2: 'TZ', name: 'Tanzanie', dialCode: '+255' },
  { iso2: 'TW', name: 'Taïwan', dialCode: '+886' },
  { iso2: 'TD', name: 'Tchad', dialCode: '+235' },
  { iso2: 'CZ', name: 'Tchéquie', dialCode: '+420' },
  { iso2: 'IO', name: 'Territoire britannique de l’océan Indien', dialCode: '+246' },
  { iso2: 'PS', name: 'Territoires palestiniens', dialCode: '+970' },
  { iso2: 'TH', name: 'Thaïlande', dialCode: '+66' },
  { iso2: 'TL', name: 'Timor oriental', dialCode: '+670' },
  { iso2: 'TG', name: 'Togo', dialCode: '+228' },
  { iso2: 'TK', name: 'Tokelau', dialCode: '+690' },
  { iso2: 'TO', name: 'Tonga', dialCode: '+676' },
  { iso2: 'TT', name: 'Trinité-et-Tobago', dialCode: '+1' },
  { iso2: 'TA', name: 'Tristan da Cunha', dialCode: '+290' },
  { iso2: 'TN', name: 'Tunisie', dialCode: '+216' },
  { iso2: 'TM', name: 'Turkménistan', dialCode: '+993' },
  { iso2: 'TR', name: 'Turquie', dialCode: '+90' },
  { iso2: 'TV', name: 'Tuvalu', dialCode: '+688' },
  { iso2: 'UA', name: 'Ukraine', dialCode: '+380' },
  { iso2: 'UY', name: 'Uruguay', dialCode: '+598' },
  { iso2: 'VU', name: 'Vanuatu', dialCode: '+678' },
  { iso2: 'VE', name: 'Venezuela', dialCode: '+58' },
  { iso2: 'VN', name: 'Viêt Nam', dialCode: '+84' },
  { iso2: 'WF', name: 'Wallis-et-Futuna', dialCode: '+681' },
  { iso2: 'YE', name: 'Yémen', dialCode: '+967' },
  { iso2: 'ZM', name: 'Zambie', dialCode: '+260' },
  { iso2: 'ZW', name: 'Zimbabwe', dialCode: '+263' },
  { iso2: 'EG', name: 'Égypte', dialCode: '+20' },
  { iso2: 'AE', name: 'Émirats arabes unis', dialCode: '+971' },
  { iso2: 'EC', name: 'Équateur', dialCode: '+593' },
  { iso2: 'ER', name: 'Érythrée', dialCode: '+291' },
  { iso2: 'VA', name: 'État de la Cité du Vatican', dialCode: '+39' },
  { iso2: 'US', name: 'États-Unis', dialCode: '+1' },
  { iso2: 'ET', name: 'Éthiopie', dialCode: '+251' },
  { iso2: 'CX', name: 'Île Christmas', dialCode: '+61' },
  { iso2: 'NF', name: 'Île Norfolk', dialCode: '+672' },
  { iso2: 'IM', name: 'Île de Man', dialCode: '+44' },
  { iso2: 'AC', name: 'Île de l’Ascension', dialCode: '+247' },
  { iso2: 'KY', name: 'Îles Caïmans', dialCode: '+1' },
  { iso2: 'CC', name: 'Îles Cocos', dialCode: '+61' },
  { iso2: 'CK', name: 'Îles Cook', dialCode: '+682' },
  { iso2: 'FO', name: 'Îles Féroé', dialCode: '+298' },
  { iso2: 'FK', name: 'Îles Malouines', dialCode: '+500' },
  { iso2: 'MP', name: 'Îles Mariannes du Nord', dialCode: '+1' },
  { iso2: 'MH', name: 'Îles Marshall', dialCode: '+692' },
  { iso2: 'SB', name: 'Îles Salomon', dialCode: '+677' },
  { iso2: 'TC', name: 'Îles Turques-et-Caïques', dialCode: '+1' },
  { iso2: 'VG', name: 'Îles Vierges britanniques', dialCode: '+1' },
  { iso2: 'VI', name: 'Îles Vierges des États-Unis', dialCode: '+1' },
  { iso2: 'AX', name: 'Îles Åland', dialCode: '+358' },
];

export function flagEmoji(iso2) {
  if (!iso2 || iso2.length !== 2) return '🏳️';
  return String.fromCodePoint(...[...iso2.toUpperCase()].map(c => 127397 + c.charCodeAt(0)));
}

export const DEFAULT_COUNTRY_ISO2 = 'MG';